<template>
  <div>
    <v-alert
      v-if="taxDetails.lainaosuus"
      class="py-6 pl-6"
      :class="{ 'text-caption' : $vuetify.breakpoint.smAndDown }"
      color="blue-grey"
      type="warning"
      prominent
      text
      icon="edit_calendar"
    >
      <v-row align="center">
        <div class="ml-5">
          <strong>
            Kaupantekopäivä:
          </strong> {{ taxDetails.kaupantekopaiva }}<br>
          <strong>Omistusoikeuden siirtyminen: </strong>
          <span :class="{ 'red--text' : datesWrong }">
            {{ taxDetails.omistusoikeuspaiva }}</span>
        </div>
        <v-spacer/>
        <v-btn
          :class="{ 'mt-4' : $vuetify.breakpoint.smAndDown }"
          class="mx-4"
          text
          :fab="mobile"
          color="primary"
          @click="modifyDatesDialog = true"
        >
          <template v-if="!mobile">
            Muokkaa
          </template>
          <v-icon v-if="mobile" dark>
            edit
          </v-icon>
        </v-btn>
      </v-row>
    </v-alert>

    <v-alert
      v-if="taxDetails.lainaosuus"
      class="py-6 pl-6"
      :class="{ 'text-caption' : $vuetify.breakpoint.smAndDown }"
      color="blue-grey"
      type="warning"
      prominent
      text
      icon="autorenew"
    >
      <v-row align="center">
        <div class="ml-5">
          <!-- single share group or real estate -->
          <template v-if="!additionalSharesVisible">
            <strong>Kauppahinta: </strong>
            {{ taxDetails.kauppahintailmanlainaosuutta.toFixed(2) | currency }}<br>
          </template>
          <template
            v-if="taxDetails.assetDetails && taxDetails.assetDetails.portionOfSellingPrice > 0"
          >
            <strong>
              Se osa kauppahinnasta, josta myös varainsiirtoverosta vapautettu ostaja
              maksaa varainsiirtoveroa:
            </strong>
            {{ taxDetails.assetDetails.portionOfSellingPrice | currency }}<br>
          </template>
          <template v-if="taxDetails.osakevaikiinteisto > 0 && !additionalSharesVisible">
            <strong>
              Yhtiölainaosuus:
            </strong> {{ taxDetails.lainaosuus | currency }}<br>
            <strong>
              Kauppahinnan vero:
            </strong> {{ taxDetails.kauppahinnanvero | currency }}<br>
            <strong>
              Yhtiölainan vero:
            </strong> {{ (taxDetails.yhtiolainanvero || '0') | currency }}<br>
          </template>

          <!-- multiple share groups -->
          <template v-if="additionalSharesVisible">
            <strong>1. Osakeryhmä:</strong>
            {{ currentProperty.osakealku }} - {{ currentProperty.osakeloppu }}
            <br>
            <strong>Kauppahinta: </strong>
            {{ taxDetails.kauppahintailmanlainaosuutta.toFixed(2) | currency }}<br>
            <strong>
              Yhtiölainaosuus:
            </strong> {{ taxDetails.lainaosuus | currency }}<br>
            <strong>
              Kauppahinnan vero:
            </strong> {{ taxDetails.kauppahinnanvero | currency }}<br>
            <strong>
              Yhtiölainan vero:
            </strong> {{ (taxDetails.yhtiolainanvero || '0') | currency }}<br>
            <template v-if="taxDetails.firstTimeBuyerTax > 0">
              <strong>
                Osin varainsiirtoverovapaiden ostajien maksama vero:
              </strong> {{ taxDetails.firstTimeBuyerTax | currency }}<br>
            </template>
            <br><strong>2. Osakeryhmä:</strong>
            {{ additionalShares.add_share }} - {{ additionalShares.add_share2 }}
            <br>
            <strong>
              Kauppahinta:
            </strong>{{ (additionalShares.shareSellingPrice
              - additionalShares.buyerShareLoan) | currency }}<br>
            <strong>
              Yhtiölainaosuus:
            </strong> {{ additionalShares.buyerShareLoan | currency }}<br>
            <strong>
              Kauppahinnan vero:
            </strong> {{ taxDetails.addSummaryTax | currency }}<br>
            <strong>
              Yhtiölainan vero:
            </strong> {{ taxDetails.addSummaryLoanTax
              ? taxDetails.addSummaryLoanTax : '0' | currency }}<br><br>
          </template>
          <template v-if="taxDetails.osakevaikiinteisto < 1 && taxDetails.firstTimeBuyerTax > 0">
            <strong>
              Osin varainsiirtoverovapaiden ostajien maksama vero:
            </strong> {{ taxDetails.firstTimeBuyerTax | currency }}<br>
          </template>
          <strong>
            Verot yhteensä:
          </strong> {{ taxDetails.yhteensavero | currency }}<br>
        </div>
      </v-row>
      <v-dialog
        v-model="modifyDatesDialog"
        persistent
        max-width="400"
      >
        <modify-tax-transfer-dates :sign-date="signDate" :transfer-date="transferDate"/>
      </v-dialog>
    </v-alert>
  </div>
</template>
<script>
import moment from 'moment';
import { mapState } from 'vuex';

export default {
  components: {
    'modify-tax-transfer-dates': () => import('@/components/taxTransfer/ModifyTaxTransferDates'),
  },
  props: {
    additionalShares: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    modifyDatesDialog: false,
  }),
  computed: {
    ...mapState({
      currentProperty: state => state.currentProperty,
      taxDetails: state => state.taxDetails,
    }),
    additionalSharesVisible() {
      return this.taxDetails.osakevaikiinteisto > 0 && this.additionalShares.add_share > 0;
    },
    datesWrong() {
      return (moment(this.taxDetails.kaupantekopaiva, 'DD.MM.YYYY') > moment(this.taxDetails.omistusoikeuspaiva, 'DD.MM.YYYY'));
    },
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    transferDate() {
      return moment(this.taxDetails.omistusoikeuspaiva, 'DD.MM.YYYY');
    },
    signDate() {
      return moment(this.taxDetails.kaupantekopaiva, 'DD.MM.YYYY');
    },
  },
  created() {
    this.$bus.$on('closeTaxTransferDatesDialog', () => {
      this.modifyDatesDialog = false;
    });
  },
};
</script>

<style scoped lang="scss">
.v-alert {
  border-radius: 8px;
}
</style>
